// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { ErrorScreen } from '../components/error-screen.js';

export function NotFound() {
  function goHome() {
    if (typeof window !== 'undefined') {
      window.location.assign('/');
    }
  }
  return (
    <ErrorScreen
      title="Page not found"
      body={
        <p>
          The page you tried to open doesn't exist. Use the button
          below to head back to the home screen.
        </p>
      }
      primaryLabel="Back to home"
      onPrimary={goHome}
    />
  );
}
